import { RootStateOrAny, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { RoomPresentationState } from './reducer';

export const selectRooms = ({ room }: RootStateOrAny): RoomPresentationState => room;

export const selectRoomWorker = createSelector(selectRooms, ({ roomWorker }) => roomWorker);
export const useRoomWorker = () => useSelector(selectRoomWorker);

export const selectSocketState = createSelector(selectRooms, ({ socketState }) => socketState);
export const useSocketState = () => useSelector(selectSocketState);

export const selectRoomSessions = createSelector(selectRooms, ({ sessions }) => sessions);
export const useRoomSessions = () => useSelector(selectRoomSessions);
